// Lib
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Utils
import { prop } from '../../../../common/utils/immutableHelper';
import { getCurrentUser } from '../../../user/currentUserSelector';
import { getIsGuestProp, getUserEmail } from '../../../../common/users/utils/userPropertyUtils';

// Actions
import { navigateToLogin } from '../../../reducers/navigationActions';
import { logout } from '../../../auth/authActions';

// Components
import ModalActionsList from '../../modal/ModalActionsList';

type Props = {
    close: () => void;
    errorNoticeData: { isRestored: boolean };
};

const BoardAccessDeniedErrorContent: React.FC<Props> = ({ close, errorNoticeData }) => {
    const currentUser = useSelector(getCurrentUser);

    const dispatch = useDispatch();

    // If the board is being restored (e.g. the user navigated directly to "app.milanote.com" without specifying
    // the board ID, then we are loading their last viewed board ID) then don't show an error, just return them to
    // their home board
    React.useEffect(() => {
        const isRestored = prop('isRestored', errorNoticeData);
        if (isRestored) close();
    }, []);

    const isGuest = getIsGuestProp(currentUser);

    const guestActions = [
        {
            text: 'Log in',
            func: (event: Event) => {
                event.preventDefault();
                dispatch(navigateToLogin());
            },
        },
    ];

    const loggedInActions = [
        {
            text: 'Log in as someone else',
            func: (event: Event) => {
                event.preventDefault();
                dispatch(logout());
            },
        },
    ];

    const actions = isGuest ? guestActions : loggedInActions;

    const loggedInMessage = isGuest ? null : (
        <p className="details secondary">
            You&apos;re currently logged in as:
            <br />
            <strong>{getUserEmail(currentUser)}</strong>
        </p>
    );

    return (
        <>
            <h2>You don&apos;t have permission to view this board</h2>
            <ModalActionsList actions={actions} />
            {loggedInMessage}
        </>
    );
};

export default BoardAccessDeniedErrorContent;
